import Link from 'next/link';
import { Fragment } from 'react';

const PRIVACY_PLACEHOLDER = '[privacy]';

type Props = {
    text: string;
    privacyPageSlug?: string;
};

/** Consent notice from the CMS; every [privacy] placeholder becomes a link to the privacy page. */
export function ConsentText({ text, privacyPageSlug }: Props) {
    const segments = text.split(PRIVACY_PLACEHOLDER);

    return (
        <>
            {segments.map((segment, index) => (
                <Fragment key={index}>
                    {segment}
                    {index < segments.length - 1 &&
                        (privacyPageSlug ? (
                            <Link href={`/m/${privacyPageSlug}`} className="underline">
                                Datenschutzerklärung
                            </Link>
                        ) : (
                            'Datenschutzerklärung'
                        ))}
                </Fragment>
            ))}
        </>
    );
}
